export { default } from './FTCDisclosureTag'
export * from './FTCDisclosureTag'
